/**
 * Large rounded shell card for dashboard-style layouts
 */

import { HTMLAttributes, ReactNode } from 'react'

interface AppCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const paddingMap = {
  none: '',
  sm: 'p-4 sm:p-5',
  md: 'p-5 sm:p-6',
  lg: 'p-6 sm:p-8',
}

export function AppCard({
  children,
  className = '',
  padding = 'md',
  ...rest
}: AppCardProps) {
  return (
    <div
      className={`rounded-shell border border-gray-200/90 bg-white shadow-shell ${paddingMap[padding]} ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
}
